export class HttpError extends Error {
    message: string;
    status: string;
    error: Error;

    constructor(error: any) {
        super(error.error.message);
        Object.setPrototypeOf(this, HttpError.prototype);

        this.error = error;

        this.message = '';
        this.status = '0';

        if (error.error && error.error.message) {
            this.message = error.error.message;
        }
        
        if (error.status) {
            this.status = error.status;
        }
    }
}